// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__M0Xzk","box":"styles_box__fqbXw","label":"styles_label__c1SpP"};